import { render, staticRenderFns } from "./ChangeOrders.vue?vue&type=template&id=f3b632ae&scoped=true&lang=pug&"
import script from "./ChangeOrders.vue?vue&type=script&lang=js&"
export * from "./ChangeOrders.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrders.vue?vue&type=style&index=0&id=f3b632ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b632ae",
  null
  
)

export default component.exports